import gql from 'graphql-tag'
import marketplaceCheckoutFragment from '../fragments/marketplace-checkout'

export default gql`
  mutation updateMarketplaceCheckoutFulfilment(
    $input: UpdateMarketplaceCheckoutFulfilmentInput!
  ) {
    checkout: updateMarketplaceCheckoutFulfilment(input: $input) {
      ...marketplaceCheckout
    }
  }

  ${marketplaceCheckoutFragment}
`
